import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FlexGrid, CellRangeEventArgs } from '@grapecity/wijmo.grid';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1505Model } from './kymw1505.model';
import { UpdateMarkPublishOrderVo } from './vo/update-mark-publish-order.model';
import { GetMarkGroupListService } from '../kymw1500/api-services/get-mark-group-list.service';
import { GetMarkPublishOrderList } from './api-services/get-mark-publish-order-list-service';
import { UpdateMarkPublishOrder } from './api-services/update-mark-publish-order-service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';

/**
 * マーク掲載順設定画面を管理するクラス
 *
 * @export KYMW1505Component
 * @class KYMW1505Component
 */
@Component({
  selector: 'app-kymw1505',
  templateUrl: 'kymw1505.component.html',
  styleUrls: ['kymw1505.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1505Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtg_MarkList', { static: true }) dtg_MarkList: FlexGrid;

  kymw1505Model: KYMW1505Model = new KYMW1505Model();
  private dragIndex: number;
  private changeFlag = false;

  /**
   *Creates an instance of KYMW1505Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1505Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getMarkGroupListService: GetMarkGroupListService,
    private getMarkPublishOrderList: GetMarkPublishOrderList,
    private updateMarkPublishOrder: UpdateMarkPublishOrder,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1505Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1505';
    this.dtg_MarkList.columnHeaders.rows[0].height = 52;
    this.dtg_MarkList.rowHeaders.columns[0].minWidth = 5;

    // マークグループ一覧取得
    this.getMarkGroupListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127', null, () => {
          this.closeFunction();
        });
      }
      this.kymw1505Model.updateMarkGroupList(data);
      // 行変更前のリストを保存
      if (this.kymw1505Model.markListMap[this.kymw1505Model.selectedMarkGroup] != null) {
        this.kymw1505Model.beforeChangeMarkList = this.kymw1505Model.markListMap[this.kymw1505Model.selectedMarkGroup].reduce((list, mark) => {
          list.push(mark);
          return list;
        },[]);
      }
    });
  }

  /**
   * 画面初期値設定
   *
   * @param groupCode マークグループコード
   * @memberof KYMW1505Component
   */
  public setInterfaceParam(groupCode: string) {
    this.kymw1505Model.selectedMarkGroup = groupCode;
    this.kymw1505Model.beforeChangeSelectedMarkGroup = groupCode;

    // マーク掲載順一覧取得取得
    // ngOnInitにあった処理だが、ここで動かないと初期表示でリストが表示できないので移動してきた
    this.getMarkPublishOrderList.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        // マーク情報が取得できませんでした
        this.dialogService.openAlertGetMessage('E0546', null, () => {
          this.closeFunction();
        });
      }
      this.kymw1505Model.updateMarkListMap(data);
      setTimeout(() => {
        // グループコンボボックス選択値に応じた表の表示とするため遅延評価
        this.eventMarkGroupName_CHANGEHandler();
      }, 500);
      setTimeout(() => {
        // 表の行の縦幅を画像表示後のサイズに調整するため遅延評価
        this.dtg_MarkList.refresh();
      }, 1000);
    });
  }

  /**
   * グループ コンボボックス 変更
   *
   * @memberof KYMW1505Component
   */
  public eventMarkGroupName_CHANGEHandler() {
    const before = this.kymw1505Model.beforeChangeSelectedMarkGroup;
    const beforeList = this.kymw1505Model.beforeChangeMarkList;

    if (this.changeFlag) {
      // 並び順の変更を破棄してもよろしいですか？
      this.dialogService.openAlertGetMessage('Q0169', null, (c) => {
        if (c === PlessAlert.Yes) {
          this.changeFlag = false;
          this.kymw1505Model.displayMarkList = this.kymw1505Model.markListMap[this.kymw1505Model.selectedMarkGroup];
          this.kymw1505Model.markListMap[before] = beforeList;
        } else {
          this.kymw1505Model.selectedMarkGroup = before;
          return;
        }
      });
    } else {
      this.kymw1505Model.displayMarkList = this.kymw1505Model.markListMap[this.kymw1505Model.selectedMarkGroup];
    }
    this.kymw1505Model.beforeChangeSelectedMarkGroup = this.kymw1505Model.selectedMarkGroup;
    if (this.kymw1505Model.markListMap[this.kymw1505Model.selectedMarkGroup] != null) {
      this.kymw1505Model.beforeChangeMarkList = this.kymw1505Model.markListMap[this.kymw1505Model.selectedMarkGroup].reduce((list, mark) => {
        list.push(mark);
        return list;
      },[]);
    }
    
  }

  /**
   * マーク 一覧 行ドラッグ
   *
   * @memberof KYMW1505Component
   */
  public onDraggingRow(s: FlexGrid, e: CellRangeEventArgs) {
    this.dragIndex = e.row;
    s.collectionView.moveCurrentToPosition(this.dragIndex);
  }

  /**
   * マーク 一覧 行ドロップ
   *
   * @memberof KYMW1505Component
   */
  public onDraggedRow(s: FlexGrid, e: CellRangeEventArgs) {
    this.changeFlag = true;
    const dropIndex = e.row;

    // 掲載順を入れ替え
    const temp = this.dtg_MarkList.rows[this.dragIndex].dataItem.publishOrder;
    this.dtg_MarkList.rows[this.dragIndex].dataItem.publishOrder = this.dtg_MarkList.rows[dropIndex].dataItem.publishOrder;
    this.dtg_MarkList.rows[dropIndex].dataItem.publishOrder = temp;

    const arr = s.collectionView.sourceCollection;
    s.collectionView.deferUpdate(() => {
      let item = arr[this.dragIndex];
      arr.splice(this.dragIndex, 1);
      arr.splice(dropIndex, 0, item);
      s.collectionView.moveCurrentToPosition(dropIndex);
    });
  }

  /**
   * 設定 ボタン 押下
   *
   * @memberof KYMW1505Component
   */
  public eventSetting_CLICKHandler() {
    let updateList: UpdateMarkPublishOrderVo[] = [];
    this.dtg_MarkList.rows.forEach((row) => {
      updateList.push(new UpdateMarkPublishOrderVo(
        row.dataItem.markCode,
        row.dataItem.publishOrder
      ))
    });
    this.updateMarkPublishOrder.execute(updateList, () => {});
    this.changeFlag = false;
  }

  /**
   * 閉じる ボタン 押下
   *
   * @memberof KYMW1505Component
   */
  onClickClose() {
    if (this.changeFlag) {
      this.dialogService.openAlertGetMessage('Q0169', null, (c) => {
        if (c === PlessAlert.Yes) {
          super.onClickClose();
        }
      });
    } else {
      super.onClickClose();
    }
  }
}
